<template>
  <VLayout column>
    <Header/>
    <ErrorPage message="No encontramos el enlace solicitado" status="404"/>
    <Footer/>
  </VLayout>
</template>
<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import ErrorPage from '@/components/ErrorPage.vue';

export default {
  name: 'NotFound',
  components: {
    Header,
    ErrorPage,
  },
};
</script>
